import { FC, useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useLoggedinUser } from '@hooks';
import { Task } from '@services';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { EntityList, EntityListItem, EntityListItemCell, IEntityListProps } from '@components/common';
import Typewriter from "typewriter-effect";


export interface ITasksListViewerProps extends IEntityListProps<Task> {
	paddingX?: number | string;
	entities: Task[];
}

export const TasksListViewer: FC<ITasksListViewerProps> = ({
	paddingX,
	entities,
	...props
}) => {
	const user = useLoggedinUser();
	const [items, setItems] = useState<Task[]>([]);

	useEffect(() => {
		let timeout: NodeJS.Timeout | undefined;
		if (entities.length > items.length) {
			timeout = setTimeout(() => {
				setItems((currentItems) => [...currentItems, entities[currentItems.length]]);
			}, 1000);
		}
		return () => {
			if (timeout !== undefined) {
				clearTimeout(timeout);
			}
		};
	}, [items, entities]);

// 	return (
// 		<EntityList
// 			entities={entities}
// 			paddingX={paddingX}
// 			{...props}
// 		>
// 			{entities.map((entity, i) => {
// 				return (
// 					<EntityListItem
// 						key={`task-${entity.id}-${i}`}
// 						sx={{ paddingRight: paddingX }}
// 						badge={<Typography variant="body2">badge change me</Typography>}
// 					>
// 						<Stack direction="column" spacing={1} sx={{ width: 1.0 }}>
// 							<Grid container>
// 								<Grid item xs={9}>
// 									{/* <EntityListItemCell title='il titolo qui'> */}
// 									<EntityListItemCell>
// 										<Typography>{entity?.text || 'Info to add'}</Typography>
// 									</EntityListItemCell>
// 								</Grid>
// 								<Grid item xs={3}>
// 									{/* <EntityListItemCell title='il titolo qui'> */}
// 									<EntityListItemCell>
// 										<a href={entity.link} target="_blank" rel="noopener noreferrer">
// 											<Typography>{entity.callToAction}</Typography>
// 										</a>
// 									</EntityListItemCell>
// 								</Grid>
// 							</Grid>
// 						</Stack>
// 					</EntityListItem>
// 				);
// 			})}
			
// 		</EntityList>
// 	);
// };
return (
	<EntityList
		entities={entities}
		paddingX={paddingX}
		{...props}
	>
		<TransitionGroup>
			{items.map((entity, i) => {
				return (
					<CSSTransition key={`task-${entity.id}-${i}`} timeout={1000} classNames="item">
						<EntityListItem
							sx={{ paddingRight: paddingX }}
							badge={<Typography variant="body2">{entity.app}</Typography>}
						>
							<Stack direction="column" spacing={1} sx={{ width: 1.0 }}>
								<Grid container>
									<Grid item xs={9}>
										<EntityListItemCell>
											<Typography>
											<Typewriter
												onInit={(typewriter) => {
													typewriter
														.typeString(entity.text)
														// .pauseFor(500)
														// .deleteAll()
														// .typeString("Welcomes You")
														.start();
												}}
												/>
											</Typography>
										</EntityListItemCell>
									</Grid>
									<Grid item xs={3}>
										<EntityListItemCell>
											<a href={entity.link} target="_blank" rel="noopener noreferrer">
												<Typography>
												{/* <Typewriter
													onInit={(typewriter) => {
														typewriter
															.typeString(entity.callToAction)
															.pauseFor(1000*i)
															// .deleteAll()
															// .typeString("Welcomes You")
															.start();
													}}
													/> */}
													{entity.callToAction}
												</Typography>
											</a>
										</EntityListItemCell>
									</Grid>
								</Grid>
							</Stack>
						</EntityListItem>
					</CSSTransition>
				);
			})}
		</TransitionGroup>
	</EntityList>
);
};